import 'react';
import img from './arrow.svg.js';
import img$1 from './chevron-big.svg.js';
import img$2 from './cross.svg.js';
import img$3 from './cog.svg.js';
import img$4 from './filter_icon.svg.js';
import img$5 from './support.svg.js';
import img$6 from './sort_icon.svg.js';
import img$7 from './minus.svg.js';
import img$8 from './plus.svg.js';

var ArrowSvg = img;
var ChevronBigSvg = img$1;
var CrossSvg = img$2;
var CogSvg = img$3;
var FilterIconSvg = img$4;
var SupportSvg = img$5;
var SortIconSvg = img$6;
var MinusSvg = img$7;
var PlusSvg = img$8;

export { ArrowSvg, ChevronBigSvg, CogSvg, CrossSvg, FilterIconSvg, MinusSvg, PlusSvg, SortIconSvg, SupportSvg };
//# sourceMappingURL=index.js.map
